import { useEffect, useRef } from 'react'

/**
 * Runs as a useEffect but ignores the first render.
 */
const useDidMountEffect = (func: () => void, deps: Array<unknown>): void => {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) func()
    else didMount.current = true
  }, deps)
}

export default useDidMountEffect
